import React, { useEffect } from 'react';
import * as styles from './ShareCard.module.scss';
import { useTranslation } from 'react-i18next';

import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';

import {
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  TelegramIcon,
  TwitterIcon,
  WhatsappIcon,
} from 'react-share';

// NOTE: This component uses window.location.href,
// which means it is only safe to be used if it is not rendered by SSR.
const ShareCard = (): React.ReactElement => {
  // useEffect(() => {
  //   document.body.style.overflow = 'hidden';
  //   return () => {
  //     document.body.style.overflow = 'visible';
  //   };
  // }, []);
  const { t } = useTranslation();

  return (
    <div className={styles.shareCardContainer}>
      <span className={styles.shareCardTitle}>
        {t('share_article.title', 'Share this article')}
      </span>
      <div className={styles.buttonsRow}>
        <FacebookShareButton url={window.location.href} className={styles.linkContainer}>
          <FacebookIcon size={32} round={true} className={styles.icon} />
          <span className={styles.linkSpan}>Facebook</span>
        </FacebookShareButton>
        <TwitterShareButton url={window.location.href} className={styles.linkContainer}>
          <TwitterIcon size={32} round={true} className={styles.icon} />
          <span className={styles.linkSpan}>Twitter</span>
        </TwitterShareButton>
        <WhatsappShareButton url={window.location.href} className={styles.linkContainer}>
          <WhatsappIcon size={32} round={true} className={styles.icon} />
          <span className={styles.linkSpan}>Whatsapp</span>
        </WhatsappShareButton>
      </div>
      <div className={styles.buttonsRow}>
        <LinkedinShareButton url={window.location.href} className={styles.linkContainer}>
          <LinkedinIcon size={32} round={true} className={styles.icon} />
          <span className={styles.linkSpan}>LinkedIn</span>
        </LinkedinShareButton>
        <TelegramShareButton url={window.location.href} className={styles.linkContainer}>
          <TelegramIcon size={32} round={true} className={styles.icon} />
          <span className={styles.linkSpan}>Telegram</span>
        </TelegramShareButton>
        <EmailShareButton url={window.location.href} className={styles.linkContainer}>
          <EmailIcon size={32} round={true} className={styles.icon} />
          <span className={styles.linkSpan}>Email</span>
        </EmailShareButton>
      </div>
    </div>
  );
};

export default ShareCard;
